import axios from "axios";
import React, { useState } from "react";
import { api } from "../utils/Api";
import { Button, notification, Modal, InputNumber, Form } from "antd";

const AddMinimumInventoryModal = ({
	addModalOpen,
	setAddModalOpen,
	onCloseModal,
	materialId,
	setMaterialId,
}) => {
	const [apiNotification, contextHolder] = notification.useNotification();

	const [loading, setLoading] = useState(false);

	const [form] = Form.useForm();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const onFinish = async (values) => {
		try {
			setLoading(true);
			const formData = {
				minimumInventory: values.minimumInventory,
			};

			const url = api + `/materialdelivered/add/minimuminventory/${materialId}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = {
				Authorization: `Bearer ${token}`,
			};

			const { data } = await axios.post(url, formData);
			if (data.success) {
				openNotification("success", "Success", data.message);
				form.resetFields();
				setLoading(false);
				onCloseModal();
			} else {
				openNotification("error", "Error", data.message);
				setLoading(false);
			}
		} catch (err) {
			setLoading(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to add delivered material",
			);
			console.error(err.message);
			return null;
		}
	};

	return (
		<Modal
			title={`Add Delivered Material`}
			open={addModalOpen}
			onCancel={() => {
				form.resetFields();
				setMaterialId(null);
				setAddModalOpen(false);
			}}
			footer={null}
			width={600}
			centered
		>
			<Form form={form} layout="vertical" onFinish={onFinish}>
				<Form.Item
					name="minimumInventory"
					label="Minimum Inventory"
					rules={[
						{
							required: true,
							message: "Missing quantity",
						},
					]}
				>
					<InputNumber
						size="large"
						style={{ width: "100%" }}
						formatter={(value) =>
							`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
						}
						parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
					/>
				</Form.Item>

				<Button
					type="primary"
					htmlType="submit"
					loading={loading}
					disabled={loading}
					size="large"
				>
					Add
				</Button>
			</Form>
			{contextHolder}
		</Modal>
	);
};

export default AddMinimumInventoryModal;
